import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';

function IconSubmission({ playerId }) {
  const [showBonusItems, setShowBonusItems] = useState([]);
  const [ownedDogs, setOwnedDogs] = useState([]);
  const [showDogId, setShowDogId] = useState('');
  const [sportingDogId, setSportingDogId] = useState('');
  const [artworkLink, setArtworkLink] = useState('');
  const [sportingArtworkLink, setSportingArtworkLink] = useState('');
  
  // FIXED: Separate states so selecting an item in one form doesn't affect the other
  const [conformationItemId, setConformationItemId] = useState('none');
  const [sportingItemId, setSportingItemId] = useState('none');
  
  const [isChampion, setIsChampion] = useState(false);
  const [message, setMessage] = useState('');

  // Helper to get ONLY iCON RNG Booster items (clean & reusable)
  const getBonusItems = (inventoryItems, shopItems) => 
    inventoryItems
      .filter(item => 
        item.quantity > 0 && 
        shopItems.some(shop => shop.itemId === item.itemId && shop.category === "iCON RNG Booster")
      )
      .map(item => ({
        ...item,
        _id: shopItems.find(shop => shop.itemId === item.itemId)._id
      }));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dogsRes, invRes, shopRes] = await Promise.all([
          fetch(`${API_BASE_URL}/my-approved-dogs/${playerId}`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } }),
          fetch(`${API_BASE_URL}/my-inventory/${playerId}`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } }),
          fetch(`${API_BASE_URL}/shop-items`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } })
        ]);

        if (!dogsRes.ok || !invRes.ok || !shopRes.ok) throw new Error('Fetch failed');

        const [dogsData, invData, shopData] = await Promise.all([
          dogsRes.json(), 
          invRes.json(), 
          shopRes.json()
        ]);

        setOwnedDogs(dogsData);

        if (dogsData.length > 0) {
          const purebredDogs = dogsData.filter(dog => 
            dog.breed && dog.breed.includes('(100%)') && !dog.breed.includes('x')
          );
          setShowDogId(purebredDogs.length > 0 ? purebredDogs[0].dogId : dogsData[0].dogId);
          setSportingDogId(dogsData[0].dogId);
        }

        // FIXED: Now only shows items with category "iCON RNG Booster"
        setShowBonusItems(getBonusItems(invData.items, shopData));
      } catch (error) {
        setMessage('Error loading data: ' + error.message);
      }
    };

    if (playerId) fetchData();
  }, [playerId]);

  const submitShowEntry = async () => {
    if (!artworkLink) {
      setMessage('Please enter an artwork link.');
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/dog-show/enter`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${localStorage.getItem('token')}` 
        },
        body: JSON.stringify({ 
          playerId, 
          dogId: showDogId, 
          artworkLink, 
          itemId: conformationItemId !== 'none' ? conformationItemId : null,
          isChampion 
        })
      });

      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setMessage(data.message);

      // Reset form
      const purebredDogs = ownedDogs.filter(dog => 
        dog.breed && dog.breed.includes('(100%)') && !dog.breed.includes('x')
      );
      setShowDogId(purebredDogs.length > 0 ? purebredDogs[0].dogId : '');
      setArtworkLink('');
      setConformationItemId('none');        // FIXED: separate reset
      setIsChampion(false);

      // Refresh bonus items (in case quantity changed)
      const invRes = await fetch(`${API_BASE_URL}/my-inventory/${playerId}`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      const shopRes = await fetch(`${API_BASE_URL}/shop-items`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      const [invData, shopData] = await Promise.all([invRes.json(), shopRes.json()]);
      setShowBonusItems(getBonusItems(invData.items, shopData));
    } catch (error) {
      setMessage('Error submitting show entry: ' + error.message);
    }
  };

  const submitSportingEntry = async () => {
    if (!sportingArtworkLink) {
      setMessage('Please enter an artwork link for Sporting Trials.');
      return;
    }
    try {
      const res = await fetch(`${API_BASE_URL}/dog-show/enter-sporting`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${localStorage.getItem('token')}` 
        },
        body: JSON.stringify({ 
          playerId, 
          dogId: sportingDogId, 
          artworkLink: sportingArtworkLink, 
          itemId: sportingItemId !== 'none' ? sportingItemId : null
        })
      });

      if (!res.ok) throw new Error(await res.text());
      const data = await res.json();
      setMessage(data.message);

      // Reset form
      setSportingDogId(ownedDogs[0]?.dogId || '');
      setSportingArtworkLink('');
      setSportingItemId('none');            // FIXED: separate reset

      // Refresh bonus items
      const invRes = await fetch(`${API_BASE_URL}/my-inventory/${playerId}`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      const shopRes = await fetch(`${API_BASE_URL}/shop-items`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      const [invData, shopData] = await Promise.all([invRes.json(), shopRes.json()]);
      setShowBonusItems(getBonusItems(invData.items, shopData));
    } catch (error) {
      setMessage('Error submitting Sporting entry: ' + error.message);
    }
  };

  // Purebred filter (used in UI)
  const purebredDogs = ownedDogs.filter(dog => 
    dog.breed && dog.breed.includes('(100%)') && !dog.breed.includes('x')
  );

  if (!playerId) return <p>Please log in.</p>;

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ textAlign: 'center', color: '#1E88E5' }}>iCON Submission</h1>
      
      {message && (
        <p style={{ 
          color: message.includes('Error') ? 'red' : 'green', 
          textAlign: 'center', 
          fontWeight: 'bold' 
        }}>
          {message}
        </p>
      )}

      {/* ==================== CONFORMATION SECTION ==================== */}
      <div style={{ 
        background: '#f9f9f9', 
        padding: '15px', 
        borderRadius: '8px', 
        marginBottom: '20px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
      }}>
        <h2 style={{ color: '#4CAF50', marginTop: 0 }}>Enter iCON RNG Conformation Show (50 DFG$)</h2>
        
        {purebredDogs.length === 0 ? (
          <p style={{ color: 'red', textAlign: 'center' }}>You have no qualified dogs to enter this event.</p>
        ) : (
          <>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Dog</label>
              <select 
                value={showDogId} 
                onChange={e => setShowDogId(e.target.value)} 
                style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
              >
                <option value="">Select a Dog</option>
                {purebredDogs.map(dog => (
                  <option key={dog.dogId} value={dog.dogId}>
                    {dog.registeredName} ({dog.dogId})
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Artwork Link (image url)</label>
              <input 
                value={artworkLink} 
                onChange={e => setArtworkLink(e.target.value)} 
                placeholder="Artwork Link" 
                style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }} 
              />
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Bonus Item</label>
              <select 
                value={conformationItemId} 
                onChange={e => setConformationItemId(e.target.value)} 
                style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
              >
                <option value="none">No Item</option>
                {showBonusItems.map(item => (
                  <option key={item._id} value={item._id}>
                    {item.name} (Qty: {item.quantity})
                  </option>
                ))}
              </select>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold' }}>
                <input 
                  type="checkbox" 
                  checked={isChampion} 
                  onChange={e => setIsChampion(e.target.checked)} 
                  style={{ marginRight: '10px' }} 
                /> 
                Enter as Champion (Testing Only)
              </label>
            </div>

            <button 
              onClick={submitShowEntry} 
              style={{ 
                backgroundColor: '#4CAF50', 
                color: 'white', 
                padding: '10px 20px', 
                border: 'none', 
                borderRadius: '5px', 
                cursor: 'pointer', 
                width: '100%' 
              }}
            >
              Enter Show
            </button>
          </>
        )}
      </div>

      {/* ==================== SPORTING SECTION ==================== */}
      <div style={{ 
        background: '#f9f9f9', 
        padding: '15px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)' 
      }}>
        <h2 style={{ color: '#4CAF50', marginTop: 0 }}>Enter iCON RNG Sporting Trials (50 DFG$)</h2>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Dog</label>
          <select 
            value={sportingDogId} 
            onChange={e => setSportingDogId(e.target.value)} 
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
          >
            <option value="">Select a Dog</option>
            {ownedDogs.map(dog => (
              <option key={dog.dogId} value={dog.dogId}>
                {dog.registeredName} ({dog.dogId})
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Artwork Link (image url)</label>
          <input 
            value={sportingArtworkLink} 
            onChange={e => setSportingArtworkLink(e.target.value)} 
            placeholder="Artwork Link" 
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }} 
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Bonus Item (iCON RNG Booster only)</label>
          <select 
            value={sportingItemId} 
            onChange={e => setSportingItemId(e.target.value)} 
            style={{ width: '100%', padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
          >
            <option value="none">No Item</option>
            {showBonusItems.map(item => (
              <option key={item._id} value={item._id}>
                {item.name} (Qty: {item.quantity})
              </option>
            ))}
          </select>
        </div>

        <button 
          onClick={submitSportingEntry} 
          style={{ 
            backgroundColor: '#4CAF50', 
            color: 'white', 
            padding: '10px 20px', 
            border: 'none', 
            borderRadius: '5px', 
            cursor: 'pointer', 
            width: '100%' 
          }}
        >
          Enter Sporting Trials
        </button>
      </div>
    </div>
  );
}

export default IconSubmission;